var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "750px",
    height: "431px",
    viewBox: "0 0 750 431",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u80CC\u666F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "33.4879111%",
    x2: "100%",
    y2: "66.5120889%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24ABFB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326FFD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 750,
    height: 431
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u80CC\\u666F"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#329EFC",
    strokeWidth: 50,
    mask: "url(#mask-3)",
    cx: 56,
    cy: 137.5,
    r: 180.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    mask: "url(#mask-3)",
    fill: "#3887FC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(489, 135)",
    id: "\\u5F62\\u72B6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.5722,227 L15.4278001,227 C6.89579996,227 0,220.152203 0,211.6992 C0,203.240792 6.90120005,196.392995 15.4278001,196.392995 L200.5722,196.392995 C209.0934,196.392995 216,203.240792 216,211.6992 C216,220.152203 209.0934,226.994595 200.5722,226.994595 L200.5722,227 Z M32.94,133.065735 L146.6262,20.3013795 L183.3732,56.7454964 L69.6870001,169.509852 L32.94,133.06033 L32.94,133.065735 Z M27.1998001,138.762324 L63.9522,175.211846 L61.6625999,177.481834 L22.7016001,188.648013 C17.1828001,190.226195 12.0636001,185.15115 13.6565999,179.676155 L24.9102,141.032312 L27.1998001,138.762324 Z M189.1188,51.0651216 L152.3664,14.6156002 L164.5164,2.56304489 C167.967143,-0.854348297 173.523457,-0.854348297 176.9742,2.56304489 L201.2526,26.6465365 C202.904883,28.276763 203.835125,30.5019788 203.835125,32.8241467 C203.835125,35.1463147 202.904883,37.3715305 201.2526,39.0017569 L189.1188,51.0651216 L189.1188,51.0651216 Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.fc723fa0ce58f867a1054a41c56d7660.svg";
export { ForwardRef as ReactComponent };